import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { throttle } from 'lodash'
// import LowcodeRenderer from "@ali/abf-lowcode-renderer";
import { micorInit } from '@ali/ysera-wei/lib/init';
// import vmsService from './vmsService';
// import WaterMark from '@ali/water-mark';
// import watermark from '@ali/cro-web-watermark'
import watermark from '@ali/web-watermark-custom'
import StarSearch from './starSearch';
import BrowserModal from './browserModal';
import UserDropdown from './userDropdown'
import Consult from './consult'
import { goLogin } from './exportUtil'
import { getAccountStatus, getUserType, aclCheck, reload, localStorageKey } from './global'
import './index.less';

interface menusItem {
  link?: string,
  title?: string,
  isActive?: boolean,
  extra?: string,
  selectMenuPath?: string[]
}
export interface IMicroTransparentLayoutProps {
  menus: menusItem[],
  containorId?: string,
  type?: string,
  isMobile?: boolean,
}

const _window = (window as any)

aclCheck()
getUserType()

// const proLinks = ['/artist-rank', '/star-source/match-baby/list', '/star-source/observe-baby/list']
// const proLinks = ['/artist-rank']
// function proMenu(link, yk_xingyuan_pro) {
//   if (!yk_xingyuan_pro) {
//     if (proLinks.indexOf(link) !== -1) {
//       return false
//     }
//   }
//   return true
// }

const noLoginLinks = ['/', '/home', '/news']
function isNoLogin(link) {
  if (noLoginLinks.indexOf(link) !== -1) {
    return true
  }
  return false
}

const userLinks = ['/star-source/save-shield']
const businessTypeArtistNoLinks = ['/star-source/match-baby/list']
function userMenu(link, useType, businessType) {
  if (useType === 2) {
    // if (userLinks.indexOf(link) !== -1) {
    //   return false
    // }
  }
  if (businessType === 1) {
    if (businessTypeArtistNoLinks.indexOf(link) !== -1) {
      return false
    }
  }
  return true
}

const hideTopRightPath = ['/', '/home']
const hideTopBar = ['/user-protocol', '/privacy-protocol']

const MicroTransparentLayout: React.FunctionComponent<IMicroTransparentLayoutProps> = function (props: IMicroTransparentLayoutProps) {
  const { containorId = 'app-root-container', isMobile } = props
  const navRef: React.RefObject<HTMLDivElement> = useRef(null)
  const containerRef: React.RefObject<HTMLDivElement> = useRef(null)
  const [pathname, setPath] = useState(window.location.pathname);
  const menus = props.menus || []

  useEffect(() => {
    if (props.type === 'micro') {
      if (Object.prototype.toString.call(_window.WEICONFIG) === "[object Array]") {
        _window.WEICONFIG = {
          config: _window.WEICONFIG,
          loading: true
        }
      }
      micorInit();
    }
  }, [])

  useEffect(() => {
    let currentNode: HTMLElement | null = null
    let scrollNode: HTMLElement | null = null
    let isTop = true
    const scroll = throttle(() => {
      // console.log(scrollNode)
      if (scrollNode && navRef.current) {
        if (scrollNode.scrollTop > 0) {
          if (!isTop) {
            return
          }
          isTop = false
          navRef.current.style.backgroundColor = '#171518'
        } else {
          if (isTop) {
            return
          }
          isTop = true
          navRef.current.style.backgroundColor = 'transparent'
        }
      }
    }, 280)
    _window.setNavScrollNode = (node: HTMLElement, sNode: HTMLElement) => {
      // console.log(containerRef.current)
      if (currentNode) {
        currentNode.removeEventListener('scroll', scroll)
      }
      if (node) {
        currentNode = node
        scrollNode = sNode || node
        currentNode.addEventListener('scroll', scroll, false)
      }
    }
    _window.setNavScrollNode(document, document.getElementsByTagName('html')[0])
    // _window.setNavScrollNode(containerRef.current)
    return () => {
      currentNode && currentNode.removeEventListener('scroll', scroll)
    }
  }, []);

  const [isLogin, seIsLogin] = useState(false)
  const [userType, setUserType] = useState<number>(_window.userType);
  const [businessType, setBusinessType] = useState<number>(_window.businessType);
  const [userData, setUserData] = useState<number>(_window.userData);
  // const [needSigned, setNeedSigned] = useState<boolean>(_window.needSignedAgreement)
  useEffect(() => {
    getAccountStatus().then(({ needSignedAgreement, isLogin, userType, businessType, userData }) => {
      seIsLogin(isLogin)
      setUserType(userType)
      setBusinessType(businessType)
      setUserData(userData)
      // setNeedSigned(needSignedAgreement)
    })
  }, [])

  useEffect(() => {
    getAccountStatus().then(({ userInfo }) => {
      if (userInfo && userInfo.empId) {
        watermark.init({
          // env: 'pre',
          // visibleContainers: [document.getElementById(containorId)],
          // invisibleContainers: [document.getElementById(containorId)],
          visibleContainers: [document.body],
          invisibleContainers: [document.body],
          empId: userInfo.empId,
          customVisible: `${userInfo.nickName || userInfo.name || ''}(${userInfo.empId})`,
          customInvisible: userInfo.empId
        });
      }
    })
  }, [containorId])

  const onItemClick = useCallback((item) => {
    const path = item.link
    // setPath(path)
    history.pushState(null, '', path)
  }, [])

  useEffect(() => {
    const appChange = (e) => {
      const detail = e.detail || {}
      const newUrl = detail.newUrl || ''
      const path = new URL(newUrl).pathname
      setPath(path)
    }
    const popState = (e) => {
      const win = e.target || _window
      const path = win.location.pathname || ''
      setPath(path)
    }
    _window.addEventListener('single-spa:before-app-change', appChange)
    _window.addEventListener('popstate', popState)
    return () => {
      _window.removeEventListener('single-spa:before-app-change', appChange)
      _window.removeEventListener('popstate', popState)
    }
  }, [])

  const menusMap = useMemo(() => {
    const list: any[] = []
    for (let i = 0; i < menus.length; i += 1) {
      const item = menus[i]
      item.selectMenuPath = []
      if (item.extra) {
        let extra = {
          selectMenuPath: ''
        }
        try {
          extra = JSON.parse(item.extra) || {}
        } catch (err) {
          console.error(err)
        }
        if (typeof extra.selectMenuPath === 'string') {
          item.selectMenuPath = extra.selectMenuPath.split(',')
        }
      }
      // const isPro = proMenu(item.link, authMap.yk_xingyuan_pro)
      // if (!isPro) {
      //   return null
      // }
      const isInUser = userMenu(item.link, userType, businessType)
      if (isInUser) {
        list.push(item)
      }
    }
    return list
  }, [menus, userType, businessType])

  const currentItem = useMemo(() => {
    for (let i = 0; i < menusMap.length; i += 1) {
      const item = menusMap[i]
      if ((item.link !== '/' && pathname.match(new RegExp('^' + item.link))) || item.link === pathname || item.selectMenuPath?.indexOf(pathname) !== -1) {
        return item
      }
    }
    return null
  }, [menusMap, pathname])

  useEffect(() => {
    if (currentItem && currentItem.title) {
      document.title = `${currentItem.title} - 星源`
    } else {
      document.title = '星源'
    }
  }, [currentItem])

  const [authMap, setAuthMap] = useState<any>(_window.authMap || {});
  useEffect(() => {
    if (_window.requestAuthPromise && typeof _window.requestAuthPromise.then === 'function') {
      _window.requestAuthPromise.then((authMap) => {
        setAuthMap(authMap)
      })
    }
  }, [])

  useEffect(() => {
    const body = document.body
    if (body && userType === 1 && authMap && authMap.yk_xingyuan_pro) {
      body.classList.add('can-select')
    }
    return () => {
      body && body.classList.remove('can-select')
    }
  }, [userType, authMap])

  useEffect(() => {
    function storageChange(e: any) {
      if (e.type === 'storage' && e.key === localStorageKey) {
        reload()
      }
    }
    window.addEventListener('storage', storageChange)
    return () => {
      window.removeEventListener('storage', storageChange)
    }
  }, []);

  const isHideTobBar = useMemo(() => {
    return hideTopBar.indexOf(pathname) !== -1
  }, [pathname])

  return (
    <div className={`micro-transparent-layout ${isMobile ? 'micro-transparent-layout-mobile' : ''}`}>
      {!isHideTobBar ? <div className={`micro-transparent-navigation${isMobile ? ' mobile' : ''}`} ref={navRef}>
        <div className="micro-transparent-nav">
          <div className="micro-transparent-logo">
            <img className="img" src="//img.alicdn.com/imgextra/i1/O1CN01U7kjTq1oGjReeKpRa_!!6000000005198-2-tps-188-100.png" />
          </div>
          <div className="micro-transparent-nav-list">
            {
              menusMap.map((item: any, index) => {
                let lightClassName = ''
                if (currentItem && currentItem.link === item.link) {
                  lightClassName = 'active'
                }
                return <div
                  key={index}
                  className={`micro-transparent-nav-item ${lightClassName}`}
                  onClick={() => {
                    if (item.link !== pathname) {
                      if (!isNoLogin(item.link) && !isLogin) {
                        goLogin()
                        return
                      }
                      onItemClick(item)
                    }
                  }}
                >
                  <div className="micro-transparent-nav-text">{item.title}</div>
                  <div className="micro-transparent-nav-line" />
                </div>
              })
            }
          </div>
        </div>
        <div className="micro-transparent-nav-right">
          <div className={`search-block${hideTopRightPath.indexOf(pathname) !== -1 ? ' hide' : ''}`}>
            <StarSearch />
          </div>
          {isLogin ? <a className="help-block" href="/help" target="_blank">
            <img className="img" src="//img.alicdn.com/imgextra/i2/O1CN01puJOAv23swo8xbwSV_!!6000000007312-2-tps-72-72.png" />
          </a> : null}
          <div className="user-block">
            <UserDropdown
              isLogin={isLogin}
              authMap={authMap}
              userType={userType}
              userData={userData}
            />
          </div>
        </div>
      </div> : null}
      <div ref={containerRef} id={containorId} className="micro-transparent-content"></div>
      {/* <ProtocolModal visible={needSigned && !isHideTobBar} onSign={onSign} /> */}
      <BrowserModal />
      <Consult />
      <div id="star-protocol"></div>
      <div id="star-offline-iframe"></div>
    </div>
  )
}

export default React.memo(MicroTransparentLayout);
